<div class="layout-topbar">
  <a class="app-logo" [routerLink]="userService.userRole === 'STAFF' ? '/dashboard/overview' : '/dashboard'">
  <img alt="app logo" 
       [src]="logo" 
       class="app-logo-img" />
  <span class="app-name">WoWInventory</span>
</a>

  <button #menubutton class="topbar-menubutton p-link" type="button" (click)="onMenuButtonClick()">
    <span></span>
  </button>

  <div class="topbar-profile">
    <button class="topbar-profile-button p-link" type="button" (click)="schoolDialogVisible = true">
      <span class="profile-details">
        <span class="schools-selection">{{
          selectedSchool?.schoolName
          }}</span>
      </span>
      <i class="pi pi-angle-down"></i>
    </button>
  </div>

  <!-- <div class="topbar-profile">
        <button
            class="topbar-profile-button p-link"
            type="button"
            pStyleClass="@next"
            enterClass="hidden"
            enterActiveClass="scalein"
            leaveToClass="hidden"
            leaveActiveClass="fadeout"
            [hideOnOutsideClick]="true"
        >
            <span class="profile-details">
                <span class="schools-selection">Kidi Acadamy</span>
            </span>
            <i class="pi pi-angle-down"></i>
        </button>
    </div> -->

  <ul class="topbar-menu">
    <li *ngFor="let item of tabs; let i = index">
      <a [routerLink]="item.routerLink" routerLinkActive="active-route" [routerLinkActiveOptions]="
                    item.routerLinkActiveOptions || {
                        paths: 'exact',
                        queryParams: 'ignored',
                        fragment: 'ignored',
                        matrixParams: 'ignored'
                    }
                " [fragment]="item.fragment" [queryParamsHandling]="item.queryParamsHandling"
        [preserveFragment]="item.preserveFragment!" [skipLocationChange]="item.skipLocationChange!"
        [replaceUrl]="item.replaceUrl!" [state]="item.state" [queryParams]="item.queryParams">
        <span>{{ item.label }}</span>
      </a>
      <i class="pi pi-times" (click)="removeTab($event, item, i)"></i>
    </li>
    <li *ngIf="!tabs || tabs.length === 0" class="topbar-menu-empty">
      
    </li>
  </ul>

  <div class="topbar-search hide-on-mobile topbar-search-active" [ngClass]="{ 'topbar-search-active': searchActive }">
    <div class="search-input-wrapper">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Search" (focus)="activateSearch()" />
      </span>
    </div>
  </div>

  <div class="mobile-search show-on-mobile">
    <button class="mobile-search-button p-link" type="button" (click)="activateSearch()">
      <i class="pi pi-search"></i>
    </button>
  </div>

  <div class="topbar-right">
    <!-- Add Button -->
    <div class="add-button-wrapper" *ngIf="userService.userRole !== 'STAFF'">
      <button pButton type="button" label="+ Add" class="custom-add-button p-link" pStyleClass="@next"
        enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout"
        [hideOnOutsideClick]="true">
        + Add
      </button>
      <!-- Dropdown menu that appears when button is clicked -->
      <ul
       *ngIf="hasAnyAddPermission()"
        class="list-none p-3 m-0 border-round shadow-2 hidden absolute surface-overlay origin-top w-full sm:w-12rem mt-2 right-0 top-auto">
        <li>
        <a
            pRipple
            *ngIf="userService.hasSchoolPermission('STAFF_CREATE')"
            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
            (click)="openAddUser($event)"
          >
            <i class="wow wow-staff mr-3" style="color: #fff;"></i>
            <span style="color: #fff;">Add User</span>
          </a>

          <a
            pRipple
            *ngIf="userService.hasSchoolPermission('CLASSROOM_CREATE')"
            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
            (click)="openAddClassroom($event)"
          >
            <i class="wow wow-classroom mr-3" style="color: #fff;"></i>
            <span style="color: #fff;">Add Classroom</span>
          </a>
          <a
              pRipple
              *ngIf="userService.hasSchoolPermission('VENDOR_CREATE')"
              class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
              (click)="openAddVendor($event)"
          >
              <i class="wow wow-inv-person mr-3" style="color: #fff;"></i>
              <span style="color: #fff;">Add Vendor</span>
          </a>

        <a
            pRipple
            *ngIf="userService.hasSchoolPermission('PRODUCT_CREATE')"
            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
            (click)="openAddProduct($event)"
        >
            <i class="wow wow-wowcare-shopping-bag mr-3" style="color: #fff;"></i>
            <span style="color: #fff;">Add Product</span>
        </a>

        <a
          pRipple
          *ngIf="userService.hasSchoolPermission('PURCHASE_CREATE')"
          class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
          (click)="openAddPurchase($event)"
        >
          <i class="wow wow-inv-purchase mr-3" style="color: #fff;"></i>
          <span style="color: #fff;">Add Purchase</span>
        </a>

      <a
          pRipple
          *ngIf="userService.hasSchoolPermission('REQUEST_CREATE')"
          class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
          (click)="openAddRequest($event)"
      >
          <i class="wow wow-inv-request mr-3" style="color: #fff;"></i>
          <span style="color: #fff;">Add Request</span>
      </a>


          <!-- Add more menu items as needed -->
        </li>
      </ul>

    </div>

    <div class="topbar-notification">
      <button class="notification-button p-link" (click)="showBellNotificationDialog()" type="button">
        <i class="wow wow-bell"></i>
    <span class="notification-badge" *ngIf="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      </button>
    </div>

    <div class="topbar-profile">
      <button class="topbar-profile-button p-link" type="button" 
      pStyleClass="@next" enterClass="hidden"
        enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">

        <!-- Profile avatar - shows image if available, otherwise shows initials -->
        <div class="profile-avatar">
          <!-- <img *ngIf="user?.id" [src]="user.profileImage" [alt]="user?.firstName + ' ' + user?.lastName"> -->
          <div class="profile-initials">
            {{ getInitials(user?.firstName, user?.lastName) }}
          </div>
        </div>

        <span class="profile-details">
          <span class="profile-name">{{user?.firstName}} {{user?.lastName}}</span>
          <span class="profile-job">{{userService.userRole | titlecase }}</span>
        </span>
        <i class="pi pi-angle-down"></i>
      </button>
      <ul
        class="list-none p-3 m-0 border-round shadow-2 hidden absolute surface-overlay origin-top w-full sm:w-12rem mt-2 right-0 top-auto">
        <li>
          <a pRipple [routerLink]="['/profile/user']" 
            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
            <i class="pi pi-user mr-3" style="color: #fff;"></i>
            <span style="color: #fff;">Profile</span>
          </a>

          <a pRipple
          [routerLink]="['/profile/user']"
            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
            <i class="pi pi-cog mr-3" style="color: #fff;"></i>
            <span style="color: #fff;">Settings</span>
          </a>

            <a
            pRipple
            href="https://help.childcarewow.com/portal/en/kb/wowinventory"
            target="_blank"
            rel="noopener noreferrer"
            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
          >
            <i class="pi pi-question-circle mr-3" style="color: #fff;"></i>
            <span style="color: #fff;">Help</span>
          </a>
          
          <a pRipple  
            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
            (click)="Logout()">
            <i class="pi pi-power-off mr-3" style="color: #fff;"></i>
            <span style="color: #fff;">Sign Out</span>
          </a>
        </li>
      </ul>
    </div>

  </div>
</div>

<p-dialog header="Select School" [(visible)]="schoolDialogVisible" [modal]="true" [style]="{ width: '400px' }"
  [closable]="true" [dismissableMask]="true">

  <ul class="school-list list-none p-0 m-0">
    <li *ngFor="let school of schools; let last = last" class="school-list-item">
      <a pRipple
        class="flex gap-3 py-3 px-3 border-round align-items-center hover: transition-colors transition-duration-150 cursor-pointer"
        [ngClass]="{
                    'selected-school': selectedSchool?.schoolCode === school.schoolCode
                }" (click)="onSchoolChange(school); schoolDialogVisible = false">
        <span style="
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        background: #80A3DC;
                        color: #fff;
                        font-weight: bold;
                        font-size: 1.1rem;
                        margin-right: 12px;
                        text-transform: uppercase;
                    ">
          {{ school.schoolName?.charAt(0) }}
        </span>
        <span class="school-name">{{ school.schoolName }}</span>
      </a>
      <hr *ngIf="!last" class="school-separator my-0" />
    </li>
  </ul>
  <ng-template pTemplate="footer">
  </ng-template>

</p-dialog>

<p-dialog [(visible)]="searchActive2" [modal]="true" [closable]="true" [dismissableMask]="true" [baseZIndex]="1000"
  [header]="'Search'" [contentStyle]="{ padding: '0' }" [style]="{width: '90vw', maxWidth: '600px', margin: '0 auto'}"
  styleClass="search-dialog-top responsive-search-dialog" [showHeader]="true" (onHide)="deactivateSearch()">
  <!-- Dialog content -->

  <div class="topbar-search-container">
    <!-- Tabs -->
    <div class="tabs">
      <button class="tab" [ngClass]="{ 'selected': selectedTab === 'Classroom' }" (click)="onTopTabSelect('Classroom')">
        Classroom
      </button>
      <button  *ngIf="userService.hasSchoolPermission('STOCK_VIEW')" class="tab" [ngClass]="{ 'selected': selectedTab === 'Stock' }" (click)="onTopTabSelect('Stock')">
        Stock
      </button>
      <button class="tab" [ngClass]="{ 'selected': selectedTab === 'Product List' }"
        (click)="onTopTabSelect('Product List')">
        Product List
      </button>
      <button  *ngIf="userService.hasSchoolPermission('STAFF_VIEW')" class="tab" [ngClass]="{ 'selected': selectedTab === 'User' }" (click)="onTopTabSelect('User')">
        User
      </button>
      <!-- other buttons... -->
      <button class="tab" [ngClass]="{ 'selected': moreoptionselectedTab === 'More' }" *ngIf="userService.userRole === 'ADMIN'"
        (click)="moreOverlay.toggle($event)">
        {{ selectedMoreOption || 'More ▼' }}
      </button>
      <!-- More options dropdown -->

      <p-overlayPanel #moreOverlay [dismissable]="true" [showCloseIcon]="false" >
        <button class="dropdown-item" *ngFor="let option of moreOptions"
          (click)="selectMoreOption(option); moreOverlay.hide()">
          {{ option }}
        </button>
      </p-overlayPanel>
    </div>

    <!-- Search Input -->
    <div class="search-bar">
      <i class="pi pi-search search-icon"></i>
      <input type="text" pInputText [formControl]="searchControl" placeholder="Search" />
    </div>
    <!-- classroom search -->
    <div class="search-results">
      <ng-container [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'Classroom'">

          <!-- Show loading spinner -->
          <div *ngIf="isLoading" class="loader-container">
            <p-progressSpinner styleClass="loader-spinner custom-spinner" strokeWidth="2" animationDuration=".5s">
            </p-progressSpinner>
          </div>
          <!-- Show no data message -->
          <div *ngIf="!isLoading && claroomSearchResults.length === 0" class="no-results">
            <i class="pi pi-info-circle" style="margin-right: 6px;"></i>
            No results found.
          </div>

          <!-- Show results -->
          <div *ngIf="!isLoading && claroomSearchResults.length > 0">
            <div *ngFor="let item of claroomSearchResults" 
            class="result-item-box cursor-pointer"
             (click)="goToClassrooms(item.name)"
            >
              <div class="name">
                Name: <strong>{{ item.name }}</strong>
              </div>
              <div class="details">
                Status: <strong>{{ item.status }}</strong>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>


    <!-- stock search -->
    <div class="search-results">
      <ng-container [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'Stock'">

          <!-- Show loading spinner -->
          <div *ngIf="isLoading" class="loader-container">
            <p-progressSpinner styleClass="loader-spinner custom-spinner" strokeWidth="2" animationDuration=".5s">
            </p-progressSpinner>
          </div>

          <!-- Show no data message -->
          <div *ngIf="!isLoading && stockSearchResults.length === 0" class="no-results">
            <i class="pi pi-info-circle" style="margin-right: 6px;"></i>
            No results found.
          </div>

          <!-- Show results -->
          <div *ngIf="!isLoading && stockSearchResults.length > 0">
            <div *ngFor="let item of stockSearchResults" class="result-item-box cursor-pointer" (click)="goToStocks(item.name)">
              <div class="name">
                Name: <strong>{{ item.name }}</strong>
              </div>
              <div class="details">
                Available Qty: <strong>{{ item.availableQty }}</strong> &nbsp;&nbsp;
                Minimum Stock Level: <strong>{{ item.minimumStockLevel }}</strong>
              </div>
            </div>
          </div>

        </ng-container>
      </ng-container>
    </div>


    <!-- product list search -->
    <div class="search-results">
      <ng-container [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'Product List'">

          <!-- Show loading spinner -->
          <div *ngIf="isLoading" class="loader-container">
            <p-progressSpinner styleClass="loader-spinner custom-spinner" strokeWidth="2" animationDuration=".5s">
            </p-progressSpinner>
          </div>

          <!-- Show no data message -->
          <div *ngIf="!isLoading && productlistSearchResults.length === 0" class="no-results">
            <i class="pi pi-info-circle" style="margin-right: 6px;"></i>
            No results found.
          </div>

          <!-- Show results -->
          <div *ngIf="!isLoading && productlistSearchResults.length > 0">
            <div *ngFor="let item of productlistSearchResults" class="result-item-box cursor-pointer" (click)="goToProductList(item.name)">
              <div class="name">Name: <strong>{{ item.name }}</strong></div>
              <div class="details">
                Available Qty: <strong>{{ item.availableQty }}</strong> &nbsp;&nbsp;
                Minimum Stock Level: <strong>{{ item.minimumStockLevel }}</strong>
              </div>
            </div>
          </div>

        </ng-container>
      </ng-container>
    </div>


    <!-- user list -->
    <div class="search-results">
      <ng-container [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'User'">

          <!-- Show loading spinner -->
          <div *ngIf="isLoading" class="loader-container">
            <p-progressSpinner styleClass="loader-spinner custom-spinner" strokeWidth="2" animationDuration=".5s">
            </p-progressSpinner>
          </div>

          <!-- Show no data message -->
          <div *ngIf="!isLoading && stafflistsearch.length === 0" class="no-results">
            <i class="pi pi-info-circle" style="margin-right: 6px;"></i>
            No results found.
          </div>

          <!-- Show user list results -->
          <div *ngIf="!isLoading && stafflistsearch.length > 0">
            <div *ngFor="let item of stafflistsearch" class="result-item-box cursor-pointer" (click)="goToUsers(item.staff?.code)">
              <div class="name">
                Name: <strong>{{ item.staff?.firstName }} {{ item.staff?.lastName }}</strong>
              </div>
              <div class="details">
                Role: <strong>{{ item.staff?.role }}</strong> &nbsp;&nbsp;
                Status: <strong>{{ item.staff?.status }}</strong>
              </div>
            </div>
          </div>

        </ng-container>
      </ng-container>
    </div>


    <!-- product categorys -->
    <div class="search-results">
      <ng-container [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'Product Category'">

          <!-- Show loading spinner -->
          <div *ngIf="isLoading" class="loader-container">
            <p-progressSpinner styleClass="loader-spinner custom-spinner" strokeWidth="2" animationDuration=".5s">
            </p-progressSpinner>
          </div>

          <!-- Show no data message -->
          <div *ngIf="!isLoading && productcategories.length === 0" class="no-results">
            <i class="pi pi-info-circle" style="margin-right: 6px;"></i>
            No results found.
          </div>

          <!-- Show results -->
          <div *ngIf="!isLoading && productcategories.length > 0">
            <div *ngFor="let item of productcategories" class="result-item-box cursor-pointer" (click)="goToProductCategory(item.name)">
              <div class="name">Name: <strong>{{ item.name }}</strong></div>
              <div class="details">
                Status: <strong>{{ item.status }}</strong> &nbsp;&nbsp;
                Product Count: <strong>{{ item.productCount }}</strong>
              </div>
            </div>
          </div>

        </ng-container>
      </ng-container>
    </div>


    <!-- vendor list -->
    <div class="search-results">
      <ng-container [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'Vendor List'">

          <!-- Show loading spinner -->
          <div *ngIf="isLoading" class="loader-container">
            <p-progressSpinner styleClass="loader-spinner custom-spinner" strokeWidth="2" animationDuration=".5s">
            </p-progressSpinner>
          </div>

          <!-- No data -->
          <div *ngIf="!isLoading && vendorlistsearch.length === 0" class="no-results">
            <i class="pi pi-info-circle" style="margin-right: 6px;"></i>
            No results found.
          </div>

          <!-- Data list -->
          <div *ngIf="!isLoading && vendorlistsearch.length > 0">
            <div *ngFor="let item of vendorlistsearch" class="result-item-box cursor-pointer" (click)="goToVendorList(item.firstName)">
              <div class="name">Name: <strong>{{ item.firstName }} {{ item.lastName }}</strong></div>
              <div class="details">
                Status: <strong>{{ item.status }}</strong> &nbsp;&nbsp;
                Mobile No: <strong>{{ item.mobile }}</strong>
              </div>
            </div>
          </div>

        </ng-container>
      </ng-container>
    </div>


    <!-- vendor category -->
    <div class="search-results">
      <ng-container [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'Vendor Category'">

          <!-- Show loading spinner -->
          <div *ngIf="isLoading" class="loader-container">
            <p-progressSpinner styleClass="loader-spinner custom-spinner" strokeWidth="2" animationDuration=".5s">
            </p-progressSpinner>
          </div>

          <!-- No data -->
          <div *ngIf="!isLoading && vendorcategoriessearch.length === 0" class="no-results">
            <i class="pi pi-info-circle" style="margin-right: 6px;"></i>
            No results found.
          </div>

          <!-- Data list -->
          <div *ngIf="!isLoading && vendorcategoriessearch.length > 0">
            <div *ngFor="let item of vendorcategoriessearch" class="result-item-box cursor-pointer" (click)="goToVendorCategory(item.name)">
              <div class="name">Name: <strong>{{ item.name }}</strong></div>
              <div class="details">
                Status: <strong>{{ item.status }}</strong> &nbsp;&nbsp;
                Vendor Count: <strong>{{ item.vendorCount }}</strong>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>


  </div>
</p-dialog>






<!---------Notifications Dialog--------->

<style>
  .button__badge {
    background-color: #fa3e3e;
    border-radius: 25px;
    color: white;
    padding: 1px 5px;
    font-size: 10px;
    position: relative;
    top: -10px;
    right: 8px;
  }
  .notification-badge {
    background-color: #fa3e3e;
    border-radius: 50%;
    color: white;
    min-width: 26px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    position: absolute;
    top: -10px;
    right: -3px;
    z-index: 1;
    box-shadow: 0 2px 6px rgba(0,0,0,0.12);
 
  }
</style>